import { render, staticRenderFns } from "./RoomWall.vue?vue&type=template&id=fdb291c2&"
import script from "./RoomWall.vue?vue&type=script&lang=js&"
export * from "./RoomWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports